import { IEvent } from "core-integration/src/store/events/types";
import {
  CountdownTimer,
  CountdownTimerLabels,
} from "plos/src/components/CountdownTimer";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { container, countdownWrapper } from "./eventDeadlineCountdown.css";

interface EventDeadlineCountdownProps {
  event: IEvent | null;
  onComplete?: () => void;
}

const EventDeadlineCountdown = ({
  event,
  onComplete,
}: EventDeadlineCountdownProps) => {
  const { t } = useTranslation("plos");

  if (!event) {
    return null;
  }

  const targetDate = new Date(event.deadline_time);

  const labels = useMemo<CountdownTimerLabels>(
    () => ({
      days: (count) => String(t("countdownTimer.day", { count })),
      hours: (count) => String(t("countdownTimer.hour", { count })),
      minutes: (count) => String(t("countdownTimer.minute", { count })),
      seconds: (count) => String(t("countdownTimer.second", { count })),
      expired: String(
        t("countdownTimer.expired", { defaultValue: "Countdown expired" }),
      ),
      timeRemaining: ({
        days,
        daysLabel,
        hours,
        hoursLabel,
        minutes,
        minutesLabel,
        seconds,
        secondsLabel,
      }) =>
        String(
          t("countdownTimer.timeRemaining", {
            days,
            daysLabel,
            hours,
            hoursLabel,
            minutes,
            minutesLabel,
            seconds,
            secondsLabel,
          }),
        ),
      deadlineAt: (formatted) =>
        String(t("countdownTimer.deadlineAt", { formatted })),
    }),
    [t],
  );

  return (
    <div className={container}>
      <h4>{event.name}</h4>
      <div className={countdownWrapper}>
        <CountdownTimer
          targetDate={targetDate}
          onComplete={onComplete}
          labels={labels}
        />
      </div>
    </div>
  );
};

export default EventDeadlineCountdown;
